import { customFetch } from "@/client/custom-fetch";

import { ILoginResponse } from "../login/login.types";
import { IConfirmAccountRequest } from "./confirm-account.types";

export const confirmAccountApi = {
  confirmAccount: async (
    data: IConfirmAccountRequest
  ): Promise<ILoginResponse> => {
    return customFetch<ILoginResponse>("/user/confirm-account", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });
  },
};
